import React from 'react'
import Social from './socialicons'
import Links from './links'
import '../../../css/components/public/footer.css'
import ScreenSizes from '../../../configTools/screenSizes';
import Mobileicons from './mobileicons';
import Chatbox from './chatbox/index';

const Index = ({setMenuOpen,openChatBox,setOpenChatBox}) => {
  const width = window.innerWidth;
  const User = JSON.parse(localStorage.getItem("user-info"));
  return (
    <>
      {width > ScreenSizes.Mobile &&
        <>
          <div className='footer_Wrapper'>
            {openChatBox.id != 0 && User &&
              <Chatbox openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/>
            }
            <div style={{
              backgroundColor:"white",
              paddingTop:"10px",
              borderTop:"1px solid #efefef"              
            }}>
              <Social/>
              <Links />
            </div>
          </div>
        </>
      }
      {width <= ScreenSizes.Mobile &&
        <div className='footer_Wrapper'>
          <Mobileicons setMenuOpen={setMenuOpen}/>
        </div>
      }
    </>
  )
}

export default Index
